import {
  SiteChatData,
  StudyChatData,
  SubmissionChatData,
  UserChatData,
  ChatData,
} from '../types/talkdesk.type';

// Type guards to check the type of chat data
export const isSubmissionChat = (chat: ChatData): chat is SubmissionChatData =>
  chat.contextType === 'submission';

export const isStudyChat = (chat: ChatData): chat is StudyChatData =>
  chat.contextType === 'study';

export const isSiteChat = (chat: ChatData): chat is SiteChatData =>
  chat.contextType === 'site';

export const isUserChat = (chat: ChatData): chat is UserChatData =>
  chat.contextType === 'user';

export const mapContext = (
  chatData: ChatData,
): { primaryId: string; chatData: ChatData } => {
  if (isSubmissionChat(chatData)) {
    return {
      primaryId: chatData.submissionId,
      chatData: {
        ...chatData,
        submissionId: chatData.submissionId,
        submissionTitle: chatData.submissionTitle,
      } as SubmissionChatData,
    };
  } else if (isStudyChat(chatData)) {
    return {
      primaryId: chatData.studyId,
      chatData: {
        ...chatData,
        studyId: chatData.studyId,
        studyName: chatData.studyName,
      } as StudyChatData,
    };
  } else if (isSiteChat(chatData)) {
    return {
      primaryId: chatData.siteId,
      chatData: {
        ...chatData,
        siteId: chatData.siteId,
        siteName: chatData.siteName,
      } as SiteChatData,
    };
  } else if (isUserChat(chatData)) {
    return {
      primaryId: chatData.userId,
      chatData: {
        ...chatData,
        userId: chatData.userId,
        userName: chatData.userName,
      } as UserChatData,
    };
  }

  // This should never happen due to the discriminated union
  throw new Error(
    `Unknown chat context type: ${(chatData as any).contextType}`,
  );
};

export const mapContextParams = (contextData: ChatData) => {
  const { primaryId, chatData } = mapContext(contextData);
  let contextParams: Record<string, any> = {};
  if (chatData.question) {
    contextParams = {
      field_option1: chatData.question,
    };
  }
  if (isSubmissionChat(chatData)) {
    contextParams = {
      ...contextParams,
      submissionId: primaryId,
      submissionTitle: chatData.submissionTitle,
    };
  } else if (isStudyChat(chatData)) {
    contextParams = {
      ...contextParams,
      studyId: primaryId,
      studyName: chatData.studyName,
    };
  } else if (isSiteChat(chatData)) {
    contextParams = {
      ...contextParams,
      siteId: primaryId,
      siteName: chatData.siteName,
    };
  } else if (isUserChat(chatData)) {
    contextParams = {
      ...contextParams,
      userId: primaryId,
      userName: chatData.userName,
    };
  }

  return contextParams;
};
